module.exports = __webpack_public_path__ + "img/partners_cont01.a8eadb54.jpg";